const routes = [
  {
    path: '/me',
    name: 'me',
    component: () => import('src/components/ContentManager/index.vue'),
    redirect: () => ({ name: 'ListSpacesRoute' }),
    children: [
      // My Account
      {
        name: 'AccountSettingsRoute',
        path: 'account',
        component: () =>
          import('src/components/ContentManager/AccountSettings/index.vue'),
        meta: { title: 'My Account' },
      },
      // My Plugins
      {
        name: 'PluginsRoute',
        path: 'plugins',
        component: () =>
          import('src/components/ContentManager/PersonalPluginsPage/index.vue'),
        meta: { title: 'My Plugins' },
      },
      {
        name: 'FieldtypeEditor',
        path: 'plugins/:fieldId',
        component: () =>
          import('src/components/ContentManager/FieldTypesEditor/index.vue'),
        meta: { title: 'Fieldtype Editor' },
      },
      // My Spaces
      {
        name: 'ListSpacesRoute',
        path: 'spaces',
        component: () =>
          import('src/components/ContentManager/ListSpaces/index.vue'),
        meta: { title: 'My Spaces' },
      },
      {
        name: 'NewSpaceRoute',
        path: 'spaces/new',
        component: () =>
          import('src/components/ContentManager/NewSpacePage/index.vue'),
        meta: { fullWidth: true, title: 'New Space' },
      },
      // Space children
      // no need to add meta.title for these, as the title needs to be the space's name
      // this is already done in the loadSpace action
      {
        name: 'SpaceEntryRoute',
        path: 'spaces/:spaceId',
        redirect: () => ({ name: 'DashboardRoute' }),
        meta: { title: 'Space' },
      },
      {
        name: 'QuickstartRoute',
        path: 'spaces/:spaceId/quickstart',
        component: () =>
          import('src/components/ContentManager/QuickstartPage/index.vue'),
        meta: { title: 'Get Started' },
      },
      {
        name: 'DashboardRoute',
        path: 'spaces/:spaceId/dashboard',
        component: () =>
          import('src/components/ContentManager/DashboardPage/index.vue'),
        meta: { title: 'Dashboard' },
      },
      {
        name: 'ListStoriesRoute',
        path: 'spaces/:spaceId/stories/:pipelineId/:releaseId/index/:folderId',
        component: () =>
          import('src/components/ContentManager/ListStories/index.vue'),
        meta: { title: 'Content' },
      },
      {
        name: 'ListTagsRoute',
        path: 'spaces/:spaceId/tags',
        component: () =>
          import('src/components/ContentManager/ListTags/index.vue'),
        meta: { title: 'Tags' },
      },
      {
        name: 'ListIdeasRoute',
        path: 'spaces/:spaceId/ideas',
        component: () =>
          import('src/components/ContentManager/ListIdeas/index.vue'),
        meta: { title: 'Ideation Room' },
      },
      {
        name: 'WritersIdeasRoute',
        meta: { sidebarClosed: true, title: 'Writing Room' },
        path: 'spaces/:spaceId/ideas/:ideaId',
        component: () =>
          import('src/components/ContentManager/WritingRoom/index.vue'),
      },
      // Concepts
      {
        name: 'ConceptRoom',
        path: 'spaces/:spaceId/concepts',
        meta: { sidebarClosed: true, title: 'Concept Room' },
        component: () =>
          import('src/components/ContentManager/ConceptRoom/ConceptRoom.vue'),
      },
      // Content Planning
      {
        name: 'ContentPlanningRoute',
        path: 'spaces/:spaceId/content-planning',
        component: () =>
          import(
            'src/components/ContentManager/ContentPlanning/ReleaseListView/ReleaseListViewPage.vue'
          ),
        meta: { title: 'Content Planner', sidebarClosed: true },
      },
      // Assets
      {
        name: 'ListAssetsRoute',
        path: 'spaces/:spaceId/assets/',
        children: [
          {
            name: 'FolderAssetsRoute',
            component: () =>
              import('src/components/ContentManager/ListAssets/index.vue'),
            path: ':folderId',
          },
        ],
        component: () =>
          import('src/components/ContentManager/ListAssets/index.vue'),
        meta: { title: 'Assets' },
      },
      {
        name: 'ListDatasourcesRoute',
        path: 'spaces/:spaceId/datasources',
        component: () =>
          import('src/components/ContentManager/ListDatasources/index.vue'),
        meta: { title: 'Datasources' },
      },
      {
        name: 'ListDatasourceEntriesRoute',
        path: 'spaces/:spaceId/datasources/:datasourceId',
        component: () =>
          import(
            'src/components/ContentManager/ListDatasourceEntries/index.vue'
          ),
        meta: { title: 'Datasource Entries' },
      },
      {
        name: 'ListActivitiesRoute',
        path: 'spaces/:spaceId/activities',
        component: () =>
          import('src/components/ContentManager/ListActivities/index.vue'),
        meta: { title: 'Activities' },
        props: (route: { params: { spaceId: string } }) => ({
          spaceId: Number(route.params.spaceId),
        }),
      },
      {
        name: 'ListTasksRoute',
        path: 'spaces/:spaceId/tasks',
        component: () =>
          import('src/components/ContentManager/ListTasks/index.vue'),
        meta: { title: 'Tasks' },
      },
      {
        name: 'BlockLibraryRoute',
        path: 'spaces/:spaceId/components/:componentId?',
        component: () =>
          import('src/components/ContentManager/BlockLibraryPage/index.vue'),
        meta: { title: 'Block Library' },
      },
      {
        name: 'ListAppsRoute',
        path: 'spaces/:spaceId/apps',
        component: () =>
          import('src/components/ContentManager/ListApps/index.vue'),
        meta: { title: 'Apps' },
      },
      {
        name: 'AppDetailRoute',
        path: 'spaces/:spaceId/apps/:appId/detail',
        meta: { fullWidth: true, title: 'App Detail' },
        component: () =>
          import('src/components/ContentManager/ListApps/AppDetail/index.vue'),
      },
      {
        name: 'AppStoreRoute',
        path: 'spaces/:spaceId/apps/:appId',
        component: () =>
          import('src/components/ContentManager/ListApps/AppStore/index.vue'),
        meta: { title: 'App Store' },
      },
      {
        path: 'spaces/:spaceId/labs',
        component: () =>
          import('src/components/ContentManager/LabsPage/LabsPage.vue'),
        children: [
          {
            path: '',
            name: 'LabsHomeRoute',
            component: () =>
              import('src/components/ContentManager/LabsPage/LabsHomePage.vue'),
          },
          {
            path: ':slug',
            name: 'LabsFeatureRoute',
            component: () =>
              import(
                'src/components/ContentManager/LabsPage/LabsInnerPage.vue'
              ),
          },
        ],
        meta: { title: 'Labs' },
      },
      {
        name: 'SettingsRoute',
        path: 'spaces/:spaceId/settings',
        component: () =>
          import('src/components/ContentManager/SettingsPage/index.vue'),
        meta: { title: 'Settings' },
      },
      // the EditorRoute and BlockEditorRoute already have their page title set in the EditorPage component
      {
        name: 'EditorRoute',
        meta: { sidebarClosed: true },
        path: 'spaces/:spaceId/stories/:pipelineId/:releaseId/:storyId',
        component: () =>
          import('src/components/ContentManager/EditorPage/index.vue'),
      },
      {
        name: 'BlockEditorRoute',
        meta: { sidebarClosed: true, discardChangesByPass: true },
        path: 'spaces/:spaceId/stories/:pipelineId/:releaseId/:storyId/blok/:blockId?/:fieldName?',
        component: () =>
          import('src/components/ContentManager/EditorPage/index.vue'),
      },
    ],
  },
]

export default routes
